import { render, staticRenderFns } from "./page_top.vue?vue&type=template&id=8639c76a&"
import script from "./page_top.vue?vue&type=script&lang=js&"
export * from "./page_top.vue?vue&type=script&lang=js&"
import style0 from "./page_top.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports